(function () {
  const config = window.hfhFavorites || {};
  if (!config.enabled) return;

  const storageKey = 'hfh:favorites:v1';
  const restockKey = 'hfh:restock:v1';
  const sessionKey = 'hfh:favorites:session';
  const accountOutboxKey = 'hfh:favorites:account-outbox:v1';
  const selectors = {
    button: '[data-hfh-favorite-button]',
    drawer: '[data-hfh-favorites-drawer]',
    list: '[data-hfh-favorites-list]',
    empty: '[data-hfh-favorites-empty]',
    close: '[data-hfh-favorites-close]',
    open: '[data-hfh-favorites-open]',
    page: '[data-hfh-favorites-page]',
    pageList: '[data-hfh-favorites-page-list]',
    pageEmpty: '[data-hfh-favorites-page-empty]',
    pageFooter: '[data-hfh-favorites-page-footer]',
    emailForm: '[data-hfh-favorites-email-form]',
    emailStatus: '[data-hfh-favorites-email-status]',
    restockForm: '[data-hfh-restock-form]',
    restockStatus: '[data-hfh-restock-status]',
    restockFields: '[data-hfh-restock-fields]',
    restockEnabled: '[data-hfh-restock-enabled]',
    addAll: '[data-hfh-favorites-add-all]',
  };

  const getStorage = (key, fallback) => {
    try {
      return JSON.parse(window.localStorage.getItem(key)) || fallback;
    } catch (error) {
      return fallback;
    }
  };

  const setStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return undefined;
    }
  };

  const getSessionId = () => {
    let sessionId = window.localStorage.getItem(sessionKey);
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.localStorage.setItem(sessionKey, sessionId);
    }
    return sessionId;
  };

  const getItems = () => getStorage(storageKey, []);
  const saveItems = (items) => setStorage(storageKey, items);
  const getAccountOutbox = () => {
    const operations = getStorage(accountOutboxKey, []);
    return Array.isArray(operations) ? operations : [];
  };
  const saveAccountOutbox = (operations) => setStorage(accountOutboxKey, operations);
  const itemKey = (item) => String(item.variantId || item.productId || '');
  const decodeHTMLEntities = (value) => {
    if (typeof value !== 'string' || !value.includes('&')) return value;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };
  const strings = Object.fromEntries(
    Object.entries(config.strings || {}).map(([key, value]) => [key, decodeHTMLEntities(value)])
  );
  const addedToCartVariantIds = new Set();
  const restockStatusCache = new Map();
  let lastActiveElement = null;
  let archiveMetadataHydrated = false;
  let accountOutboxReplay = null;

  const escapeHTML = (value) =>
    String(value || '').replace(/[&<>"']/g, (character) => {
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };
      return map[character];
    });

  const normalizeItem = (button) => {
    const archiveProduct = button.dataset.archiveProduct === 'true';

    return {
      productId: button.dataset.productId,
      variantId: button.dataset.variantId,
      handle: button.dataset.handle,
      title: button.dataset.title,
      url: button.dataset.url,
      image: button.dataset.image,
      price: archiveProduct ? '' : button.dataset.price,
      variantTitle: button.dataset.variantTitle,
      available: button.dataset.available === 'true',
      archiveProduct,
      archiveProductKnown: true,
      locale: config.locale,
      country: config.country,
      createdAt: new Date().toISOString(),
    };
  };

  const normalizeStoredItem = (item) => {
    const archiveProductKnown =
      item.archiveProductKnown === true || Object.prototype.hasOwnProperty.call(item, 'archiveProduct');
    const archiveProduct = item.archiveProduct === true || item.archiveProduct === 'true';

    return {
      productId: item.productId,
      variantId: item.variantId,
      handle: item.handle,
      title: item.title,
      url: item.url,
      image: item.image,
      price: archiveProduct ? '' : item.price,
      variantTitle: item.variantTitle,
      available: item.available !== false,
      archiveProduct,
      archiveProductKnown,
      locale: item.locale || config.locale,
      country: item.country || config.country,
      createdAt: item.createdAt || new Date().toISOString(),
    };
  };

  const findItem = (items, key) => items.find((item) => itemKey(item) === key);
  const isAddedToCart = (variantId) => addedToCartVariantIds.has(String(variantId || ''));
  const normalizeEmail = (email) => String(email || '').trim().toLowerCase();
  const restockRequestTarget = (request) =>
    request.intentType === 'FUTURE_STYLE_INTEREST'
      ? request.productId || ''
      : request.variantId || request.productId || '';
  const restockRequestKey = (request) =>
    `${restockRequestTarget(request)}:${request.intentType || 'EXACT_RESTOCK_REQUEST'}:${
      request.customerId || request.sessionId || normalizeEmail(request.email) || ''
    }`;
  const getRestockRequests = () => getStorage(restockKey, []);
  const restockRequestBelongsToCurrentVisitor = (request, email = '') => {
    const requestCustomerId = String(request.customerId || '');

    if (config.customerId) {
      if (requestCustomerId) return requestCustomerId === String(config.customerId);
      return Boolean(config.customerEmail) && normalizeEmail(request.email) === normalizeEmail(config.customerEmail);
    }

    if (requestCustomerId) return false;
    if (request.sessionId) return String(request.sessionId) === getSessionId();
    return Boolean(email) && normalizeEmail(request.email) === normalizeEmail(email);
  };
  const findRestockRequest = (targetId, email = '', intentType = '') =>
    getRestockRequests().find((request) => {
      const sameTarget = String(restockRequestTarget(request)) === String(targetId || '');
      if (!sameTarget || (intentType && request.intentType !== intentType)) return false;
      return restockRequestBelongsToCurrentVisitor(request, email);
    });
  const saveRestockRequest = (request) => {
    const requests = getRestockRequests();
    const requestKey = restockRequestKey(request);
    setStorage(restockKey, [request, ...requests.filter((savedRequest) => restockRequestKey(savedRequest) !== requestKey)]);
  };

  const setAddButtonAdded = (button, variantId) => {
    if (!button) return;
    addedToCartVariantIds.add(String(variantId));
    button.textContent = strings.addedToCart;
    button.classList.add('is-added');
    button.setAttribute('aria-disabled', 'true');
  };

  const mergeFavoriteItems = (...groups) => {
    const merged = [];
    groups.flat().forEach((item) => {
      if (!item) return;
      const normalized = normalizeStoredItem(item);
      const key = itemKey(normalized);
      if (!key || findItem(merged, key)) return;
      merged.push(normalized);
    });

    return merged.sort((first, second) => {
      const firstDate = Date.parse(first.createdAt) || 0;
      const secondDate = Date.parse(second.createdAt) || 0;
      return secondDate - firstDate;
    });
  };

  const postBackend = (endpoint, payload) => {
    if (!config.backendEnabled || !config.backendPath) return Promise.resolve({ skipped: true });

    return fetch(`${config.backendPath}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        ...payload,
        sessionId: getSessionId(),
        customerId: config.customerId,
        customerEmail: config.customerEmail,
        locale: config.locale,
        country: config.country,
      }),
    }).then((response) => {
      if (!response.ok) throw new Error(`Favorites request failed: ${response.status}`);
      return response.json().catch(() => ({}));
    });
  };

  const getBackend = (endpoint) => {
    if (!config.backendEnabled || !config.backendPath) return Promise.resolve({ skipped: true });

    return fetch(`${config.backendPath}${endpoint}`, {
      headers: { Accept: 'application/json' },
    }).then((response) => {
      if (!response.ok) throw new Error(`Favorites request failed: ${response.status}`);
      return response.json().catch(() => ({}));
    });
  };

  const newOutboxOperationId = () =>
    window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const pendingAccountOutbox = () =>
    getAccountOutbox().filter((operation) => operation.customerId === String(config.customerId || ''));

  const replayAccountOutbox = () => {
    if (!config.backendEnabled || !config.customerId) return Promise.resolve({ skipped: true });
    if (accountOutboxReplay) return accountOutboxReplay;

    accountOutboxReplay = (async () => {
      let operation = pendingAccountOutbox()[0];
      while (operation) {
        try {
          await postBackend(operation.type === 'remove' ? '/remove' : '/add', { item: operation.item });
          saveAccountOutbox(getAccountOutbox().filter((entry) => entry.id !== operation.id));
        } catch (error) {
          saveAccountOutbox(
            getAccountOutbox().map((entry) =>
              entry.id === operation.id
                ? { ...entry, attempts: Number(entry.attempts || 0) + 1, lastAttemptAt: new Date().toISOString() }
                : entry
            )
          );
          return { pending: true };
        }
        operation = pendingAccountOutbox()[0];
      }
      return { ok: true };
    })().finally(() => {
      accountOutboxReplay = null;
    });

    return accountOutboxReplay;
  };

  const queueAccountMutation = (type, item) => {
    if (!config.backendEnabled || !config.customerId || !itemKey(item)) return Promise.resolve({ skipped: true });
    const operation = {
      id: newOutboxOperationId(),
      type,
      item,
      customerId: String(config.customerId),
      createdAt: new Date().toISOString(),
      attempts: 0,
    };
    saveAccountOutbox([...getAccountOutbox(), operation]);
    return replayAccountOutbox();
  };

  const syncAccountFavorites = () => {
    if (!config.backendEnabled || !config.customerId) return Promise.resolve();

    return postBackend('/sync', { items: getItems() })
      .then((response) => {
        if (response.skipped) return;
        if (!Array.isArray(response.items)) return;
        saveItems(mergeFavoriteItems(response.items));
        renderAll();
      })
      .catch(() => undefined);
  };

  const archiveMetadataURL = (item) => {
    try {
      const url = new URL(item.url, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      url.searchParams.delete('variant');
      ['preview_theme_id', '_fd', 'pb'].forEach((parameter) => {
        const value = new URLSearchParams(window.location.search).get(parameter);
        if (value) url.searchParams.set(parameter, value);
      });
      return url.toString();
    } catch (error) {
      return '';
    }
  };

  const hydrateArchiveMetadata = () => {
    if (archiveMetadataHydrated) return Promise.resolve();
    archiveMetadataHydrated = true;

    const items = mergeFavoriteItems(getItems());
    const products = new Map();
    items
      .filter((item) => !item.archiveProductKnown)
      .forEach((item) => {
        const url = archiveMetadataURL(item);
        if (item.productId && url && !products.has(String(item.productId))) {
          products.set(String(item.productId), url);
        }
      });

    if (products.size === 0) return Promise.resolve();

    return Promise.all(
      Array.from(products, ([productId, url]) =>
        fetch(url, { headers: { Accept: 'text/html' } })
          .then((response) => {
            if (!response.ok) return null;
            return response.text();
          })
          .then((html) => {
            if (!html) return null;
            const page = new DOMParser().parseFromString(html, 'text/html');
            const button = Array.from(page.querySelectorAll(selectors.button)).find(
              (candidate) => String(candidate.dataset.productId || '') === productId
            );
            if (!button?.hasAttribute('data-archive-product')) return null;
            return [productId, button.dataset.archiveProduct === 'true'];
          })
          .catch(() => null)
      )
    ).then((results) => {
      const archiveProducts = new Map(results.filter(Boolean));
      if (archiveProducts.size === 0) return;

      let changed = false;
      const nextItems = items.map((item) => {
        const productId = String(item.productId || '');
        if (!archiveProducts.has(productId)) return item;
        const archiveProduct = archiveProducts.get(productId);
        changed = true;
        return {
          ...item,
          archiveProduct,
          archiveProductKnown: true,
          price: archiveProduct ? '' : item.price,
        };
      });

      if (!changed) return;
      saveItems(nextItems);
      renderAll();
    });
  };

  const pushEvent = (eventName, item) => {
    const payload = {
      event: eventName,
      product_id: item.productId,
      variant_id: item.variantId,
      handle: item.handle,
      variant_title: item.variantTitle,
      locale: config.locale,
      customer_status: config.customerId ? 'logged_in' : 'guest',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    postBackend('/event', { eventType: eventName, item }).catch(() => undefined);
  };

  const syncButtons = () => {
    const items = mergeFavoriteItems(getItems());
    let changed = false;
    document.querySelectorAll(selectors.button).forEach((button) => {
      const key = button.dataset.variantId || button.dataset.productId;
      const savedItem = findItem(items, key);
      const isSaved = Boolean(savedItem);
      if (savedItem && button.hasAttribute('data-archive-product')) {
        const archiveProduct = button.dataset.archiveProduct === 'true';
        if (
          !savedItem.archiveProductKnown ||
          savedItem.archiveProduct !== archiveProduct ||
          (archiveProduct && savedItem.price)
        ) {
          savedItem.archiveProduct = archiveProduct;
          savedItem.archiveProductKnown = true;
          if (archiveProduct) savedItem.price = '';
          changed = true;
        }
      }
      const text = button.querySelector('[data-hfh-favorite-text]');
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute(
        'aria-label',
        isSaved ? strings.removeProduct || button.dataset.hfhSavedLabel : button.dataset.hfhSaveLabel
      );
      if (text) text.textContent = isSaved ? button.dataset.hfhSavedLabel : button.dataset.hfhSaveLabel;
    });
    if (changed) saveItems(items);
  };

  const displayVariantTitles = new Map();
  const displayRequests = new Set();
  const hydrateDisplayVariantTitles = () => {
    document.querySelectorAll(selectors.button).forEach((button) => {
      if (button.dataset.variantId && button.hasAttribute('data-display-variant-title')) {
        displayVariantTitles.set(String(button.dataset.variantId), button.dataset.displayVariantTitle);
      }
    });
    const root = window.Shopify?.routes?.root || '/';
    getItems().forEach((item) => {
      if (!item.handle || !item.productId || displayVariantTitles.has(String(item.variantId)) || displayRequests.has(String(item.productId))) return;
      displayRequests.add(String(item.productId));
      fetch(`${root}products/${encodeURIComponent(item.handle)}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : null)
        .then((product) => {
          if (!product || String(product.id) !== String(item.productId) || !Array.isArray(product.variants)) return;
          product.variants.forEach((variant) => displayVariantTitles.set(String(variant.id), window.hfhSizeLabels?.variant(variant, product) || variant.title));
          renderDrawer();
          renderPage();
        })
        .catch(() => undefined);
    });
  };

  const renderItem = (item, source) => {
    const variant = item.variantTitle && item.variantTitle !== 'Default Title' ? (displayVariantTitles.get(String(item.variantId)) || item.variantTitle) : '';
    const addedToCart = isAddedToCart(item.variantId);
    const restockRequest =
      findRestockRequest(item.variantId || item.productId) || findRestockRequest(item.productId);
    const availabilityStatus = !item.available
      ? `<p class="hfh-favorite-item__availability">${escapeHTML(strings.currentlyUnavailable)}</p>`
      : '';
    const restockStatus =
      !item.available && restockRequest
        ? `<p class="hfh-favorite-item__restock">${escapeHTML(restockRequest.successMessage || strings.restockEnabled)}</p>`
        : '';
    const addButton = item.available
      ? `<button type="button" class="button button--primary hfh-favorite-item__add${
          addedToCart ? ' is-added' : ''
        }" data-hfh-favorites-add="${escapeHTML(item.variantId)}"${
          addedToCart ? ' aria-disabled="true"' : ''
        }>${escapeHTML(addedToCart ? strings.addedToCart : strings.addToCart)}</button>`
      : `<a class="button button--primary hfh-favorite-item__add" href="${escapeHTML(item.url)}">${escapeHTML(
          strings.viewProduct
        )}</a>`;

    return `
      <article class="hfh-favorite-item" data-hfh-favorite-item="${escapeHTML(itemKey(item))}">
        <a class="hfh-favorite-item__media" href="${escapeHTML(item.url)}" aria-label="${escapeHTML(item.title)}">
          ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="hfh-favorite-item__content">
          <h3 class="hfh-favorite-item__title"><a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a></h3>
          ${variant ? `<p class="hfh-favorite-item__meta">${escapeHTML(variant)}</p>` : ''}
          ${!item.archiveProduct && item.price ? `<p class="hfh-favorite-item__price">${escapeHTML(item.price)}</p>` : ''}
          ${availabilityStatus}
          ${restockStatus}
          <div class="hfh-favorite-item__actions">
            ${addButton}
            <button type="button" class="hfh-favorite-item__remove" data-hfh-favorites-remove="${escapeHTML(
              itemKey(item)
            )}" data-hfh-source="${source}">${escapeHTML(strings.remove)}</button>
          </div>
        </div>
      </article>
    `;
  };

  const renderCollection = (container, emptyNode, source) => {
    if (!container) return;
    const items = getItems();
    container.innerHTML = items.map((item) => renderItem(item, source)).join('');
    if (emptyNode) emptyNode.hidden = items.length > 0;
  };

  const isFavoritesPage = () => {
    const path = window.location.pathname.replace(/\/+$/, '');
    return /\/pages\/favorites$/i.test(path);
  };

  const ensureFavoritesPage = () => {
    const existingPage = document.querySelector(selectors.page);
    if (existingPage || !isFavoritesPage()) return existingPage;

    const main = document.getElementById('MainContent');
    if (!main) return null;

    main.innerHTML = `
      <div class="hfh-favorites-page page-width" data-hfh-favorites-page>
        <header class="hfh-favorites-page__header">
          <p class="caption-with-letter-spacing">${escapeHTML(strings.pageEyebrow)}</p>
          <h1 class="hfh-favorites-page__title">${escapeHTML(strings.pageTitle)}</h1>
          <p class="hfh-favorites-page__intro">${escapeHTML(strings.pageIntro)}</p>
        </header>
        <div class="hfh-favorites-page__list" data-hfh-favorites-page-list></div>
        <div class="hfh-favorites-page__footer" data-hfh-favorites-page-footer hidden>
          <a href="${escapeHTML(
            config.allProductsUrl || '/collections/all'
          )}" class="button button--secondary hfh-favorites-page__continue">
            ${escapeHTML(strings.continueBrowsing)}
          </a>
        </div>
        <div class="hfh-favorites-page__empty" data-hfh-favorites-page-empty hidden>
          <p>${escapeHTML(strings.emptyState)}</p>
          <a href="${escapeHTML(
            config.allProductsUrl || '/collections/all'
          )}" class="button button--secondary hfh-favorites-page__continue">
            ${escapeHTML(strings.continueBrowsing)}
          </a>
        </div>
      </div>
    `;

    return main.querySelector(selectors.page);
  };

  const getCartAddCandidates = () => {
    const seen = new Set();
    return getItems().filter((item) => {
      const variantId = String(item.variantId || '');
      if (!item.available || !variantId || isAddedToCart(variantId) || seen.has(variantId)) return false;
      seen.add(variantId);
      return true;
    });
  };

  const updateAddAllButton = (drawer) => {
    const addAllButton = drawer.querySelector(selectors.addAll);
    if (!addAllButton) return;
    const availableItems = getItems().filter((item) => item.available && item.variantId);
    const candidates = getCartAddCandidates();
    const allAdded = availableItems.length > 0 && candidates.length === 0;
    addAllButton.hidden = availableItems.length === 0;
    addAllButton.textContent = allAdded ? strings.addedAllToCart : strings.addAllToCart;
    if (allAdded) {
      addAllButton.setAttribute('aria-disabled', 'true');
    } else {
      addAllButton.removeAttribute('aria-disabled');
    }
  };

  const renderDrawer = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    renderCollection(drawer.querySelector(selectors.list), drawer.querySelector(selectors.empty), 'drawer');
    updateAddAllButton(drawer);
    const emailForm = drawer.querySelector(selectors.emailForm);
    if (emailForm) {
      emailForm.hidden = !config.emailCaptureEnabled || !config.backendEnabled || getItems().length < 2;
    }
  };

  const renderPage = () => {
    const page = ensureFavoritesPage();
    if (!page) return;
    const items = getItems();
    renderCollection(page.querySelector(selectors.pageList), page.querySelector(selectors.pageEmpty), 'page');
    const footer = page.querySelector(selectors.pageFooter);
    if (footer) footer.hidden = items.length === 0;
  };

  const normalizeRestockState = (value) => {
    const state = value && typeof value === 'object' ? value : { restockStatus: value };
    const restockStatus = state.restockStatus === 'RESTOCK_CONFIRMED'
      ? 'RESTOCK_CONFIRMED'
      : 'PERMANENTLY_UNAVAILABLE';
    const extendedLeadTime = restockStatus === 'RESTOCK_CONFIRMED' && state.extendedLeadTime === true;
    return {
      restockStatus,
      extendedLeadTime,
      customerTimingNote: extendedLeadTime ? String(state.customerTimingNote || '').trim() : '',
    };
  };

  const restockPresentation = (state) => {
    const restockState = normalizeRestockState(state);
    if (restockState.restockStatus === 'RESTOCK_CONFIRMED') {
      return {
        operationalStatus: restockState.restockStatus,
        intentType: 'EXACT_RESTOCK_REQUEST',
        title: strings.restockConfirmedTitle,
        body: restockState.extendedLeadTime
          ? restockState.customerTimingNote || strings.restockConfirmedExtendedBody || strings.restockConfirmedBody
          : strings.restockConfirmedBody,
        button: strings.restockConfirmedButton,
        success: strings.restockConfirmedSuccess || strings.restockEnabled,
        emailRequired: true,
      };
    }

    return {
      operationalStatus: 'PERMANENTLY_UNAVAILABLE',
      intentType: 'FUTURE_STYLE_INTEREST',
      title: strings.restockPermanentTitle,
      body: strings.restockPermanentBody,
      button: strings.restockPermanentButton,
      success: strings.futureStyleSuccess,
      emailRequired: false,
      futureStyle: true,
    };
  };

  const restockTargetForForm = (form) =>
    form.dataset.intentType === 'FUTURE_STYLE_INTEREST'
      ? form.dataset.productId
      : form.dataset.variantId || form.dataset.productId;

  const restockSuccessForIntent = (intentType) => {
    if (intentType === 'FUTURE_STYLE_INTEREST') return strings.futureStyleSuccess || strings.restockEnabled;
    return strings.restockConfirmedSuccess || strings.restockEnabled;
  };

  const restockCompanionControl = (form, attribute) =>
    Array.from(document.querySelectorAll(`[${attribute}]`)).find(
      (element) => element.getAttribute(attribute) === form.id
    );

  const syncFutureContactFields = (form, presentation) => {
    const futureContact = restockCompanionControl(form, 'data-hfh-future-contact');
    const contactInput = futureContact?.querySelector('input');
    const emailInput = form.querySelector('[name="email"]');
    const emailField = emailInput?.closest('[data-hfh-restock-email]');
    const isFutureStyle = Boolean(presentation.futureStyle);

    if (futureContact) {
      futureContact.hidden = !isFutureStyle;
      futureContact.toggleAttribute('hidden', !isFutureStyle);
      futureContact.setAttribute('aria-hidden', String(!isFutureStyle));
    }
    if (contactInput) {
      contactInput.disabled = !isFutureStyle;
      if (!isFutureStyle) contactInput.checked = false;
    }

    if (!emailInput || emailInput.type === 'hidden') return;

    const contactRequested = isFutureStyle && Boolean(contactInput?.checked);
    const showEmail = !isFutureStyle || contactRequested;
    if (emailField) {
      emailField.hidden = !showEmail;
      emailField.toggleAttribute('hidden', !showEmail);
    }
    emailInput.disabled = !showEmail;
    emailInput.required = isFutureStyle ? contactRequested : Boolean(presentation.emailRequired);
  };

  const applyRestockPresentation = (form, state) => {
    const presentation = restockPresentation(state);
    if (presentation.futureStyle && form.dataset.archiveProduct === 'true') {
      presentation.body = strings.archiveUnavailable || presentation.body;
    }
    form.dataset.intentType = presentation.intentType;
    form.dataset.operationalStatus = presentation.operationalStatus;
    form.classList.toggle('is-future-style', Boolean(presentation.futureStyle));

    const title = form.querySelector('[data-hfh-restock-title]');
    const body = form.querySelector('[data-hfh-restock-body]');
    const button = form.querySelector('[data-hfh-restock-button]');
    const emailInput = form.querySelector('[name="email"]');
    const marketingConsent = restockCompanionControl(form, 'data-hfh-restock-marketing');

    if (title) title.textContent = presentation.title || '';
    if (body) body.textContent = presentation.body || '';
    if (button) {
      button.textContent = presentation.button || '';
      button.disabled = false;
    }
    if (emailInput && emailInput.type !== 'hidden') {
      if (!emailInput.dataset.defaultPlaceholder) emailInput.dataset.defaultPlaceholder = emailInput.placeholder;
      emailInput.placeholder = presentation.futureStyle
        ? strings.futureStyleEmailOptional || emailInput.dataset.defaultPlaceholder
        : emailInput.dataset.defaultPlaceholder;
    }
    if (marketingConsent) {
      const hideMarketingConsent = Boolean(presentation.futureStyle);
      marketingConsent.hidden = hideMarketingConsent;
      marketingConsent.toggleAttribute('hidden', hideMarketingConsent);
      marketingConsent.setAttribute('aria-hidden', String(hideMarketingConsent));
      const input = marketingConsent.querySelector('input');
      if (input) {
        input.disabled = hideMarketingConsent;
        if (hideMarketingConsent) input.checked = false;
      }
    }
    syncFutureContactFields(form, presentation);

    return presentation;
  };

  const syncRestockForms = () => {
    document.querySelectorAll(selectors.restockForm).forEach((form) => {
      const email = form.querySelector('[name="email"]')?.value || config.customerEmail || '';
      const request = form.dataset.intentType === 'FUTURE_STYLE_INTEREST'
        ? null
        : findRestockRequest(restockTargetForForm(form), email, form.dataset.intentType);
      const fields = form.querySelector(selectors.restockFields);
      const enabled = form.querySelector(selectors.restockEnabled);
      const status = form.querySelector(selectors.restockStatus);
      form.classList.toggle('is-enabled', Boolean(request));
      if (fields) fields.hidden = Boolean(request);
      if (enabled) {
        enabled.hidden = !request;
        if (request) enabled.textContent = request.successMessage || restockSuccessForIntent(request.intentType);
      }
      if (status && request) status.hidden = true;
    });
  };

  const hydrateRestockForm = (form) => {
    const presentation = form.querySelector('[data-hfh-restock-button]');
    const key = `${form.dataset.productId || ''}:${form.dataset.variantId || ''}`;
    const apply = (state) => {
      applyRestockPresentation(form, state);
      syncRestockForms();
    };

    if (!config.backendEnabled || !config.restockEnabled || !form.dataset.productId) {
      apply({ restockStatus: 'PERMANENTLY_UNAVAILABLE' });
      return Promise.resolve();
    }

    if (restockStatusCache.has(key)) {
      apply(restockStatusCache.get(key));
      return Promise.resolve();
    }

    if (form.dataset.hfhRestockStatusLoading === 'true') return Promise.resolve();
    form.dataset.hfhRestockStatusLoading = 'true';
    if (presentation) presentation.disabled = true;

    const params = new URLSearchParams({ productId: form.dataset.productId });
    if (form.dataset.variantId) params.set('variantId', form.dataset.variantId);
    return getBackend(`/restock-status?${params.toString()}`)
      .then((response) => {
        const state = normalizeRestockState(response);
        restockStatusCache.set(key, state);
        apply(state);
      })
      .catch(() => apply({ restockStatus: 'PERMANENTLY_UNAVAILABLE' }))
      .finally(() => {
        delete form.dataset.hfhRestockStatusLoading;
      });
  };

  const hydrateRestockForms = () =>
    Promise.all(Array.from(document.querySelectorAll(selectors.restockForm), hydrateRestockForm));

  const renderAll = () => {
    hydrateDisplayVariantTitles();
    syncButtons();
    renderDrawer();
    renderPage();
    syncRestockForms();
    hydrateRestockForms();
  };

  const openDrawer = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    lastActiveElement = document.activeElement;
    renderDrawer();
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      drawer.querySelector('[role="dialog"]')?.focus();
    });
  };

  const closeDrawer = (options = {}) => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer || drawer.hidden) return;
    const shouldRestoreFocus = options.restoreFocus !== false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    window.setTimeout(() => {
      drawer.hidden = true;
      if (shouldRestoreFocus) lastActiveElement?.focus?.();
    }, 220);
  };

  const toggleFavorite = (button) => {
    const item = normalizeItem(button);
    const key = itemKey(item);
    const items = getItems();
    const existing = findItem(items, key);

    if (existing) {
      const nextItems = items.filter((savedItem) => itemKey(savedItem) !== key);
      saveItems(nextItems);
      if (config.customerId) queueAccountMutation('remove', item).catch(() => undefined);
      pushEvent('favorite_remove', item);
    } else {
      const nextItems = [item, ...items.filter((savedItem) => itemKey(savedItem) !== key)];
      saveItems(nextItems);
      if (config.customerId) queueAccountMutation('add', item).catch(() => undefined);
      pushEvent('favorite_add', item);
      openDrawer();
    }

    renderAll();
  };

  const removeFavorite = (key) => {
    const items = getItems();
    const item = findItem(items, key);
    saveItems(items.filter((savedItem) => itemKey(savedItem) !== key));
    if (item) {
      if (config.customerId) queueAccountMutation('remove', item).catch(() => undefined);
      pushEvent('favorite_remove', item);
    }
    renderAll();
  };

  const getCart = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const getCartFormRequestConfig = () => {
    const requestConfig =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    requestConfig.headers = requestConfig.headers || {};
    requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete requestConfig.headers['Content-Type'];
    return requestConfig;
  };

  const appendCartSections = (payload, cart) => {
    if (!cart?.getSectionsToRender) return;
    const sections = cart.getSectionsToRender().map((section) => section.id);
    if (payload instanceof FormData) {
      payload.append('sections', sections);
      payload.append('sections_url', window.location.pathname);
    } else {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    cart.setActiveElement?.(document.activeElement);
  };

  const renderCartSections = (response, cart) => {
    if (!cart || !response?.sections || !cart.getSectionsToRender) return;
    cart.getSectionsToRender().forEach((section) => {
      try {
        const sectionHtml = response.sections[section.id];
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (!sectionHtml || !sectionElement) return;
        const sectionDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const nextElement = section.selector
          ? sectionDocument.querySelector(section.selector)
          : sectionDocument.querySelector('.shopify-section') || sectionDocument.getElementById(section.id);
        if (nextElement?.innerHTML) sectionElement.innerHTML = nextElement.innerHTML;
      } catch (error) {
        console.error(error);
      }
    });
    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    cart.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cart.close?.bind(cart));
  };

  const handleCartSuccess = (response, variantIds, cart, options = {}) => {
    variantIds.forEach((variantId) => addedToCartVariantIds.add(String(variantId)));
    variantIds.forEach((variantId) => {
      const item = findItem(getItems(), String(variantId));
      if (item) pushEvent('favorite_add_to_cart', item);
    });
    if (!cart) {
      window.location = window.routes?.cart_url || '/cart';
      return;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'hfh-favorites',
        productVariantId: variantIds[0],
        cartData: response,
      });
    }
    renderDrawer();
    renderPage();
    if (options.openCart !== false && typeof cart.renderContents === 'function' && response?.sections) {
      closeDrawer({ restoreFocus: false });
      cart.renderContents(response);
      return;
    }
    renderCartSections(response, cart);
  };

  const handleCartError = (response, variantId) => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'hfh-favorites',
        productVariantId: variantId,
        errors: response.errors || response.description,
        message: response.message,
      });
    }
    throw new Error(response.description || response.message || window.cartStrings?.error);
  };

  const addVariantToCart = (variantId, cart) => {
    if (!variantId || !window.routes?.cart_add_url) return;
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    appendCartSections(formData, cart);
    const requestConfig = getCartFormRequestConfig();
    requestConfig.body = formData;

    return fetch(window.routes.cart_add_url, requestConfig)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) handleCartError(response, variantId);
        return response;
      });
  };

  const addToCart = (variantId, button) => {
    if (!variantId || !window.routes?.cart_add_url) return;
    const cart = getCart();
    button?.setAttribute('aria-disabled', 'true');
    if (button) button.textContent = strings.addingToCart;

    addVariantToCart(variantId, cart)
      .then((response) => {
        setAddButtonAdded(button, variantId);
        handleCartSuccess(response, [variantId], cart, { openCart: true });
      })
      .catch((error) => {
        console.error(error);
        if (button && !isAddedToCart(variantId)) button.textContent = strings.addToCart;
      })
      .finally(() => {
        if (button && !isAddedToCart(variantId)) button.removeAttribute('aria-disabled');
      });
  };

  const addAllToCart = (button) => {
    if (!window.routes?.cart_add_url || button?.getAttribute('aria-disabled') === 'true') return;
    const items = getCartAddCandidates();
    if (items.length === 0) return;
    const cart = getCart();
    const variantIds = items.map((item) => item.variantId);
    button?.setAttribute('aria-disabled', 'true');
    if (button) button.textContent = strings.addingAllToCart;

    variantIds
      .reduce(
        (promise, variantId) => promise.then(() => addVariantToCart(variantId, cart)),
        Promise.resolve()
      )
      .then((response) => {
        handleCartSuccess(response, variantIds, cart, { openCart: true });
      })
      .catch((error) => {
        console.error(error);
        if (button) {
          button.textContent = strings.addAllToCart;
          button.removeAttribute('aria-disabled');
        }
      });
  };

  const handleEmailCapture = (form) => {
    const status = form.querySelector(selectors.emailStatus);
    const formData = new FormData(form);
    const email = formData.get('email');
    const marketingOptIn = formData.get('marketing_opt_in') === 'true';

    postBackend('/capture-email', {
      email,
      marketingOptIn,
      items: getItems(),
    })
      .then(() => {
        if (status) {
          status.textContent = strings.emailSuccess;
          status.hidden = false;
        }
        form.reset();
      })
      .catch(() => {
        if (status) {
          status.textContent = strings.emailError;
          status.hidden = false;
        }
      });
  };

  const handleRestock = (form) => {
    const status = form.querySelector(selectors.restockStatus);
    const formData = new FormData(form);
    const email = formData.get('email') || config.customerEmail || '';
    const intentType = form.dataset.intentType || 'EXACT_RESTOCK_REQUEST';
    const isFutureStyleInterest = intentType === 'FUTURE_STYLE_INTEREST';

    // Favorites are the sole storefront demand signal for permanently unavailable products.
    if (isFutureStyleInterest) return;

    if (!config.backendEnabled) {
      if (status) {
        status.textContent = strings.restockDraft;
        status.hidden = false;
      }
      return;
    }

    const payload = {
      email,
      customerId: config.customerId || '',
      sessionId: config.customerId ? '' : getSessionId(),
      marketingOptIn: formData.get('marketing_opt_in') === 'true',
      productId: form.dataset.productId,
      variantId: form.dataset.variantId,
      handle: form.dataset.handle,
      title: form.dataset.title,
      variantTitle: form.dataset.variantTitle,
      url: form.dataset.url,
      requestedAt: new Date().toISOString(),
      intentType,
      restockStatusAtRequest: form.dataset.operationalStatus || 'RESTOCK_CONFIRMED',
      preferredVariantId: isFutureStyleInterest ? form.dataset.variantId : '',
      contactPermission: formData.get('contact_permission') === 'true',
    };

    postBackend(isFutureStyleInterest ? '/future-style-interest' : '/restock', payload)
      .then((response) => {
        if (response?.ok !== true || !response.id) {
          throw new Error('Restock request was not confirmed');
        }
        const savedIntentType = response.intentType || intentType;
        const savedRequest = {
          ...payload,
          intentType: savedIntentType,
          successMessage: restockSuccessForIntent(savedIntentType),
        };
        saveRestockRequest(savedRequest);
        if (status) {
          status.textContent = savedRequest.successMessage;
          status.hidden = false;
        }
        form.reset();
        syncRestockForms();
        renderDrawer();
        renderPage();
        pushEvent(
          isFutureStyleInterest ? 'future_style_interest' : 'restock_request',
          savedRequest
        );
      })
      .catch(() => {
        if (status) {
          status.textContent = config.backendEnabled ? strings.emailError : strings.restockDraft;
          status.hidden = false;
        }
      });
  };

  const init = () => {
    renderAll();
    replayAccountOutbox()
      .then(() => syncAccountFavorites())
      .finally(hydrateArchiveMetadata);

    window.addEventListener('online', () => {
      replayAccountOutbox().then(() => syncAccountFavorites()).catch(() => undefined);
    });

    document.addEventListener('click', (event) => {
      const favoriteButton = event.target.closest(selectors.button);
      if (favoriteButton) {
        event.preventDefault();
        toggleFavorite(favoriteButton);
        return;
      }

      if (event.target.closest(selectors.open)) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const drawer = document.querySelector(selectors.drawer);
      if (event.target.closest(selectors.close) || (drawer && event.target === drawer)) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const removeButton = event.target.closest('[data-hfh-favorites-remove]');
      if (removeButton) {
        removeFavorite(removeButton.dataset.hfhFavoritesRemove);
        return;
      }

      const addAllButton = event.target.closest(selectors.addAll);
      if (addAllButton) {
        event.preventDefault();
        addAllToCart(addAllButton);
        return;
      }

      const addButton = event.target.closest('[data-hfh-favorites-add]');
      if (addButton) {
        event.preventDefault();
        if (addButton.getAttribute('aria-disabled') === 'true') return;
        addToCart(addButton.dataset.hfhFavoritesAdd, addButton);
      }
    });

    document.addEventListener('submit', (event) => {
      const emailForm = event.target.closest(selectors.emailForm);
      if (emailForm) {
        event.preventDefault();
        handleEmailCapture(emailForm);
        return;
      }

      const restockForm = event.target.closest(selectors.restockForm);
      if (restockForm) {
        event.preventDefault();
        handleRestock(restockForm);
      }
    });

    document.addEventListener('change', (event) => {
      const futureContact = event.target.closest('[data-hfh-future-contact]');
      if (!futureContact) return;
      const form = event.target.form || document.getElementById(futureContact.dataset.hfhFutureContact);
      if (!form) return;
      syncFutureContactFields(form, {
        futureStyle: form.dataset.intentType === 'FUTURE_STYLE_INTEREST',
        emailRequired: form.dataset.intentType !== 'FUTURE_STYLE_INTEREST',
      });
      const emailInput = form.querySelector('[name="email"]');
      if (event.target.checked && emailInput?.type !== 'hidden') emailInput.focus();
    });

    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') closeDrawer();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.setTimeout(renderAll, 0);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

